import React, { ReactNode } from 'react';
import Txt from 'components/atoms/Txt/Txt';
import classes from './EmptyStatus.module.scss';
import clsx from 'clsx';

export interface EmptyStatusProps {
  messageHighlight?: string;
  message?: string | ReactNode;
  messageClassName?: string;
}

const EmptyStatus: React.FC<EmptyStatusProps> = ({
  messageHighlight,
  message,
  messageClassName,
}) => {
  return (
    <div className={classes.root}>
      <div className={classes.content}>
        {messageHighlight && (
          <Txt component="p" className={classes.messageHighlight}>
            {messageHighlight}
          </Txt>
        )}
        {message &&
          (typeof message === 'string' ? (
            <Txt component="p" className={classes.message}>
              {message}
            </Txt>
          ) : (
            <div className={clsx(classes.message, messageClassName && classes[messageClassName])}>
              {message}
            </div>
          ))}
      </div>
    </div>
  );
};

export default EmptyStatus;
